import {
  mapQueryCopilotAllUsers,
  mapQueryCopilotConversations,
  mapQueryCopilotConversationsCount,
  mapQueryCopilotUsers,
  queryCopilotAllUsers,
  queryCopilotConversations,
  queryCopilotConversationsCount,
  queryCopilotUsers
} from './queries'
import graphqlService from '../../../../../services/graphqlService'
import apiService from '../../../../../services/api/apiService'
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

export interface FileAttachment {
  name: string
  type: string
}
export interface ConversationItem {
  id: string
  name: string
  conversationId: string
  documentsCount: number
  appType: string
  attachmentsCount: number
  user: string
  filesCount: number
  attributesCount: number
  entitiesCount: number
  postTime: string
  attachments: FileAttachment[]
  attributes: string[]
  entities: string[]
}
export interface ConversationUser {
  id: string
  name: string
  conversationsCount: number
  filesCount: number
  attributesCount: number
  entitiesCount: number
}

export interface CopilotUser {
  id: string
  name: string
}

export type AppTypeItem = {
  id: string
  name: string
}
export interface CopilotConversationsState {
  list: ConversationItem[]
  totalList: number
  cards: ConversationUser[]
  totalCards: number
  allUsers: CopilotUser[]
  appTypesList: AppTypeItem[]
}

export const initialState: CopilotConversationsState = {
  list: [],
  totalList: 0,
  cards: [],
  totalCards: 0,
  allUsers: [],
  appTypesList: []
}

export type FetchConversationsParams = {
  datasourceId: string
  filter?: {
    key: string
    values: string[]
  }[]
  booleanFilter?: {
    key: string
    value: boolean
  }[]
  page: number
  pageSize: number
}

export const ACTION_FETCH_COPILOT_CONVERSATIONS = 'copilot/conversations'
export const fetchCopilotConversations = createAsyncThunk(
  ACTION_FETCH_COPILOT_CONVERSATIONS,
  async (params: FetchConversationsParams) => {
    const rawResponse = await graphqlService.execute(queryCopilotConversations(params))
    return mapQueryCopilotConversations(rawResponse)
  }
)

export const ACTION_FETCH_COPILOT_CONVERSATIONS_COUNT = 'copilot/conversations/count'
export const fetchCopilotConversationsCount = createAsyncThunk(
  ACTION_FETCH_COPILOT_CONVERSATIONS_COUNT,
  async (params: FetchConversationsParams) => {
    const rawResponse = await graphqlService.execute(queryCopilotConversationsCount(params))
    return mapQueryCopilotConversationsCount(rawResponse)
  }
)

export type FetchUsersParams = {
  filter?: {
    key: string
    values: string[]
  }[]
  booleanFilter?: {
    key: string
    value: boolean
  }[]
}

export const ACTION_FETCH_COPILOT_USERS = 'copilot/users'
export const fetchCopilotUsers = createAsyncThunk(
  ACTION_FETCH_COPILOT_USERS,
  async (params: FetchUsersParams) => {
    const rawResponse = await graphqlService.execute(queryCopilotUsers(params))
    return mapQueryCopilotUsers(rawResponse)
  }
)

export const ACTION_FETCH_COPILOT_ALL_USERS = 'copilot/allUsers'
export const fetchCopilotAllUsers = createAsyncThunk(
  ACTION_FETCH_COPILOT_ALL_USERS,
  async (params: FetchUsersParams) => {
    const rawResponse = await graphqlService.execute(queryCopilotAllUsers(params))
    return mapQueryCopilotAllUsers(rawResponse)
  }
)

export const ACTION_FETCH_COPILOT_APP_TYPES_LIST = 'copilot/appTypes/list'
export const fetchCopilotAppTypesList = createAsyncThunk(
  ACTION_FETCH_COPILOT_APP_TYPES_LIST,
  async (params: { datasourceId: string }) => {
    return await apiService.getCopilotAppTypes(params.datasourceId)
  }
)

const conversationsSlice = createSlice({
  name: 'conversations',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchCopilotConversations.fulfilled, (state, { payload }) => {
      state.list = payload.list
    })
    builder.addCase(fetchCopilotConversationsCount.fulfilled, (state, { payload }) => {
      state.totalList = payload.totalList
    })
    builder.addCase(fetchCopilotUsers.fulfilled, (state, { payload }) => {
      state.cards = payload.list
      state.totalCards = payload.totalList
    })
    builder.addCase(fetchCopilotAllUsers.fulfilled, (state, { payload }) => {
      state.allUsers = payload
    })
    builder.addCase(fetchCopilotAppTypesList.fulfilled, (state, { payload }) => {
      state.appTypesList = Object.entries(payload).map(([name, id]: any) => ({
        id,
        name
      }))
    })
  }
})

export default conversationsSlice.reducer
